export default "__VITE_ASSET__DfuEq2kh__"